module.exports = {
	"260": {
		"dk": {
			"name": "Colorado Avalanche",
			"slug": "colorado-avalanche"
		},
		"en": {
			"name": "Colorado Avalanche",
			"slug": "colorado-avalanche"
		}
	},
	"262": {
		"dk": {
			"name": "Vancouver Canucks",
			"slug": "vancouver-canucks"
		}
	},
	"263": {
		"dk": {
			"name": "Anaheim Ducks",
			"slug": "anaheim-ducks"
		}
	},
	"271": {
		"dk": {
			"name": "Detroit Red Wings",
			"slug": "detroit-red-wings"
		}
	},
	"272": {
		"dk": {
			"name": "Chicago Blackhawks",
			"slug": "chicago-blackhawks"
		}
	},
	"274": {
		"dk": {
			"name": "New York Islanders",
			"slug": "new-york-islanders"
		}
	},
	"275": {
		"dk": {
			"name": "Pittsburgh Penguins",
			"slug": "pittsburgh-penguins"
		}
	},
	"278": {
		"dk": {
			"name": "Montreal Canadiens",
			"slug": "montreal-canadiens"
		}
	},
	"283": {
		"dk": {
			"name": "Florida Panthers",
			"slug": "florida-panthers"
		}
	},
	"286": {
		"dk": {
			"name": "Philadelphia Flyers",
			"slug": "philadelphia-flyers"
		}
	},
	"306": {
		"hasCustomLogo": true,
		"dk": {
			"name": "Jokerit",
			"slug": "jokerit"
		}
	},
	"379": {
		"dk": {
			"name": "New York Rangers",
			"slug": "new-york-rangers"
		}
	},
	"393": {
		"dk": {
			"name": "SoenderjyskE",
			"slug": "soenderjyske"
		}
	},
	"8391": {
		"dk": {
			"name": "FC København",
			"slug": "fc-kobenhavn"
		}
	},
	"8455": {
		"dk": {
			"name": "Chelsea",
			"slug": "chelsea"
		}
	},
	"8586": {
		"dk": {
			"name": "Tottenham",
			"slug": "tottenham"
		}
	},
	"8595": {
		"dk": {
			"name": "Brøndby IF",
			"slug": "brondby-if"
		}
	},
	"8633": {
		"dk": {
			"name": "Real Madrid",
			"slug": "real-madrid"
		}
	},
	"8634": {
		"dk": {
			"name": "Barcelona",
			"slug": "fc-barcelona"
		}
	},
	"8636": {
		"dk": {
			"name": "Inter",
			"slug": "inter"
		}
	},
	"8650": {
		"dk": {
			"name": "Liverpool",
			"slug": "liverpool"
		}
	},
	"9789": {
		"dk": {
			"name": "Borussia Dortmund",
			"slug": "borussia-dortmund"
		}
	},
	"9823": {
		"dk": {
			"name": "Bayern München",
			"slug": "bayern-munchen"
		}
	},
	"9825": {
		"dk": {
			"name": "Arsenal",
			"slug": "arsenal"
		}
	},
	"9847": {
		"dk": {
			"name": "Paris Saint Germain",
			"slug": "paris-saint-germain"
		}
	},
	"9885": {
		"dk": {
			"name": "Juventus",
			"slug": "juventus"
		}
	},
	"10260": {
		"dk": {
			"name": "Manchester United",
			"slug": "manchester-united"
		}
	},
	"10267": {
		"dk": {
			"name": "Valencia",
			"slug": "valencia"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/teams.json
// module id = 1109
// module chunks = 0 1